module.exports = __webpack_public_path__ + "static/media/users_active.4e51f373.svg";